import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { create, update } from "../../services/upload-files.service";
import { useDispatch, useSelector } from "react-redux";
import { addEmployee, start, updateDepartment, updateEmployee } from "../../store/slices/TeamManagementSlice";
import useFetch from "../../hooks/useFetch";

const AddEmployee = ({ selectedRow, setShowOffcanvas, showOffcanvas, setSelectedRow, operation }) => {
    const [formData, setFormData] = useState();
    const [isChecked, setIsChecked] = useState(selectedRow.is_supervisor);
    const [errors, setErrors] = useState({});
    const empLoadMaster = useSelector((state) => state.teammanagement.data.mastereditemp);
    const { data } = useFetch('role');

    const userdetails = JSON.parse(localStorage.getItem('userdetails'));

    const dispatch = useDispatch();

    useEffect(() => {
        setIsChecked(selectedRow.is_supervisor);
    }, [selectedRow.is_supervisor]);

    const handleInputChange = (event) => {
        const { name, value, checked } = event.target;
        if (name === 'is_supervisor') {
            setIsChecked(checked);
            setSelectedRow((prevSelectedRow) => ({
                ...prevSelectedRow,
                is_supervisor: checked,
                supervisor_id: checked ? null : prevSelectedRow.supervisor_id,
            }));
        } else {
            setSelectedRow((prevSelectedRow) => ({
                ...prevSelectedRow,
                [name]: value,
            }));
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear the error message for the corresponding field
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (selectedRow.name.trim() === "") {
            newErrors.name = "Please Enter Employee Name";
        }

        if (selectedRow.email.trim() === "") {
            newErrors.email = "Please Enter an Email Address";
        } else if (!validateEmail(selectedRow.email)) {
            newErrors.email = "Please Enter a Valid Email Address";
        }

        if (selectedRow.contact.trim() === "") {
            newErrors.contact = "Please Enter a Mobile Number";
        } else if (!validateMobileNumber(selectedRow.contact)) {
            newErrors.contact = "Please Enter a Valid Mobile Number";
        }

        if (selectedRow.department_id === "") {
            newErrors.department_id = "Please Select a Department";
        }

        if (!selectedRow.is_supervisor && selectedRow.supervisor_id === "") {
            newErrors.supervisor_id = "Please Select a Supervisor";
        }

        if (selectedRow.designation === "") {
            newErrors.designation = "Please Select a Designation";
        }

        if (selectedRow.role_id === "") {
            newErrors.role_id = "Please Select a Role";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (validateForm()) {
            setFormData(
                operation === "update"
                    ? {
                        id: selectedRow.id,
                        name: selectedRow.name,
                        user_id: selectedRow.user_id,
                        email: selectedRow.email,
                        contact: selectedRow.contact,
                        is_supervisor: selectedRow.is_supervisor,
                        supervisor_id: selectedRow.is_supervisor === 1 ? null : selectedRow.supervisor_id,
                        department_id: selectedRow.department_id,
                        designation: selectedRow.designation,
                        role_id: selectedRow.role_id,
                        type: "NA",
                    }
                    : {
                        name: selectedRow.name,
                        email: selectedRow.email,
                        contact: selectedRow.contact,
                        is_supervisor: selectedRow.is_supervisor == true ? 1 : 0,
                        supervisor_id: selectedRow.supervisor_id,
                        department_id: selectedRow.department_id,
                        designation: selectedRow.designation,
                        role_id: selectedRow.role_id,
                        company_id: userdetails.company_id,
                        type: "NA",
                    }
            );

            setShowOffcanvas(false);
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateMobileNumber = (mobileNumber) => {
        const mobileNumberRegex = /^\d{10}$/;
        return mobileNumberRegex.test(mobileNumber);
    };

    useEffect(() => {
        if (formData) {
            dispatch(start());
            if (operation === "create") {
                create(formData, "employee").then((res) => {
                    dispatch(addEmployee(res));
                });
            } else {
                update(formData, "employee").then((res) => {
                    dispatch(updateEmployee(res));
                });
            }
        }
    }, [formData, dispatch]);

    const resetForm = (event) => {
        event.preventDefault();
        setSelectedRow({
            id: "",
            name: "",
            user_id: "",
            email: "",
            contact: "",
            is_supervisor: false,
            supervisor_id: null,
            department_id: null,
            designation: null,
            role_id: null,
            status: "1"
        });
        setIsChecked(false);
        setErrors({});
    };

    const handleClose = () => {
        setSelectedRow({
            id: "",
            name: "",
            user_id: "",
            email: "",
            contact: "",
            is_supervisor: false,
            supervisor_id: null,
            department_id: null,
            designation: null,
            role_id: null,
            status: "1"
        });
        setIsChecked(false);
        setErrors({});
        setShowOffcanvas(false);
    };

    return (
        <Offcanvas
            show={showOffcanvas}
            onHide={handleClose}
            placement="end"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{operation === "create" ? "Add" : "Edit"} Employee</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="InputName" className="form-label">Employee Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            id="InputName"
                            name="name"
                            aria-describedby="nameHelp"
                            value={selectedRow.name || ""}
                            onChange={handleInputChange}
                        />
                        {errors.name && <div className="text-danger small">{errors.name}</div>}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="InputEmail" className="form-label">Email:</label>
                        <input
                            type="email"
                            className="form-control"
                            id="InputEmail"
                            name="email"
                            aria-describedby="emailHelp"
                            value={selectedRow.email || ""}
                            onChange={handleInputChange}
                            disabled={operation !== 'create'}
                        />
                        {errors.email && <div className="text-danger small">{errors.email}</div>}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="InputNumber" className="form-label">Contact Number:</label>
                        <input
                            type="text"
                            className="form-control"
                            id="InputNumber"
                            name="contact"
                            aria-describedby="numberHelp"
                            value={selectedRow.contact || ""}
                            onChange={handleInputChange}
                        />
                        {errors.contact && <div className="text-danger small">{errors.contact}</div>}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="department_id" className="form-label">Department:</label>
                        <select
                            className="form-select"
                            name="department_id"
                            id="department_id"
                            aria-label="Default select example"
                            onChange={handleInputChange}
                            value={selectedRow.department_id || ""}
                        >
                            <option value="" >Select Department</option>
                            {empLoadMaster.departments && empLoadMaster.departments.length > 0 ? (
                                empLoadMaster.departments.map((dep) => (
                                    <option key={dep.id} value={dep.id}>
                                        {dep.department_name}
                                    </option>
                                ))
                            ) : (
                                <option disabled>No Department data available.</option>
                            )}
                        </select>
                        {errors.department_id && <div className="text-danger small">{errors.department_id}</div>}
                    </div>

                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="is_supervisor"
                            name="is_supervisor"
                            checked={isChecked}
                            onChange={handleInputChange}
                        />
                        <label className="form-check-label" htmlFor="is_supervisor">
                            Is Supervisor?
                        </label>
                    </div>
                    
                    {!isChecked && (
                        <div className="mb-3">
                            <label htmlFor="supervisor_id" className="form-label">Supervisor:</label>
                            <select
                                className="form-select"
                                name="supervisor_id"
                                id="supervisor_id"
                                aria-label="Default select example"
                                onChange={handleInputChange}
                                value={selectedRow.supervisor_id || ""}
                            >
                                <option value="">Select Supervisor</option>
                                {empLoadMaster.supervisors && empLoadMaster.supervisors.length > 0 ? (
                                    empLoadMaster.supervisors.map((sup) => (
                                        <option key={sup.id} value={sup.id}>
                                            {sup.name}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No Supervisor data available.</option>
                                )}
                            </select>
                            {errors.supervisor_id && <div className="text-danger small">{errors.supervisor_id}</div>}
                        </div>
                    )}

                    <div className="mb-3">
                        <label htmlFor="employee_designation" className="form-label">Designation:</label>
                        <select
                            className="form-select"
                            name="designation"
                            id="employee_designation"
                            aria-label="Default select example"
                            onChange={handleInputChange}
                            value={selectedRow.designation || ""}
                        >
                            <option value="">Select Designation</option>
                            {empLoadMaster.designations && empLoadMaster.designations.length > 0 ? (
                                empLoadMaster.designations.map((des) => (
                                    <option key={des.id} value={des.id}>
                                        {des.name}
                                    </option>
                                ))
                            ) : (
                                <option disabled>No Designation data available.</option>
                            )}
                        </select>
                        {errors.designation && <div className="text-danger small">{errors.designation}</div>}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="employee_role" className="form-label">Select Role</label>
                        <select
                            className="form-select"
                            name="role_id"
                            id="employee_role"
                            aria-label="Default select example"
                            onChange={handleInputChange}
                            value={selectedRow.role_id || ""}
                        >
                            <option value="">Select Role</option>
                            {data.data && data.data.length > 0 ? (
                                data.data.map((role) => (
                                    <option key={role.id} value={role.id}>
                                        {role.role_name}
                                    </option>
                                ))
                            ) : (
                                <option disabled>No Roles available.</option>
                            )}
                        </select>
                        {errors.role_id && <div className="text-danger small">{errors.role_id}</div>}
                    </div>

                    <div className="mb-3">
                        <label htmlFor="status" className="form-label">User Status:</label>
                        <select
                            className="form-select"
                            name="status"
                            id="status"
                            aria-label="Default select example"
                            onChange={handleInputChange}
                            value={selectedRow.status || "1"}
                            disabled={operation === 'create'}
                        >
                            <option value="1">Active</option>
                            <option value="2">Inactive</option>
                        </select>
                    </div>

                    <div className="d-flex gap-2">
                        <button type="submit" className="btn btn-primary btn-add">
                            {operation === "create" ? "Add" : "Update"}
                        </button>
                        <button type="reset" className="btn btn-primary btn-add">Reset</button>
                        
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default AddEmployee;